import { render, staticRenderFns } from "./ShipCompany.vue?vue&type=template&id=2fc1a33e&scoped=true&"
import script from "./ShipCompany.vue?vue&type=script&lang=js&"
export * from "./ShipCompany.vue?vue&type=script&lang=js&"
import style0 from "./ShipCompany.vue?vue&type=style&index=0&id=2fc1a33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1a33e",
  null
  
)

export default component.exports